<!-- <fa (click)="reportAnIssue()" name="fa fa-info-circle"></fa> -->
<div class="cursor-pointer" (click)="reportAnIssue()" >
    <img src="../../../../../assets/images/exclamation.svg" height="30" width="30"   />
</div>
